import {Vector2} from "./vector2";

export class Bounds2 {
    static oneEmpty = new Bounds2(Vector2.zero, Vector2.one);
    static zeroEmpty = new Bounds2(Vector2.zero, Vector2.zero);

    public max: Vector2;
    public min: Vector2;

    constructor(arg1: Vector2 | number[][] | DOMRect, arg2?: Vector2) {
        if (arg1 instanceof Vector2 && arg2 !== undefined) {
            this.max = new Vector2(Math.max(arg1.x, arg2.x), Math.max(arg1.y, arg2.y));
            this.min = new Vector2(Math.min(arg1.x, arg2.x), Math.min(arg1.y, arg2.y));
        } else if (arg1 instanceof DOMRect) {
            this.max = new Vector2(arg1.x + arg1.width, arg1.y + arg1.height);
            this.min = new Vector2(arg1.x, arg1.y);
        } else {
            const numbers = arg1 as number[][];

            this.min = new Vector2(numbers[0]);
            this.max = new Vector2(numbers[1]);
        }
    }

    constrain(point: Vector2) {
        return new Vector2(
            Math.min(Math.max(point.x, this.min.x), this.max.x),
            Math.min(Math.max(point.y, this.min.y), this.max.y));
    }
    contains(test: Vector2) {
        return test.x >= this.min.x && test.x <= this.max.x && test.y >= this.min.y && test.y <= this.max.y;
    }
    equals(compare: Bounds2) {
        return this.min.equals(compare.min) && this.max.equals(compare.max);
    }
    //Grow by an geometric multiplier, either as a vector or a number
    expand(size: number | Vector2) {
        const multiplier = size instanceof Vector2 ? size : new Vector2(size, size);

        return new Bounds2(this.min.multiply(multiplier), this.max.multiply(multiplier));
    }
    // Grow by a linear amount, either as a vector or a number
    grow(size: number | Vector2) {
        const difference = size instanceof Vector2 ? size : new Vector2(size, size);

        return new Bounds2(this.min.minus(difference), this.max.plus(difference));
    }
    height() {
        return this.max.y - this.min.y;
    }
    minus(offset: Vector2) {
        return new Bounds2(this.min.minus(offset), this.max.minus(offset));
    }
    multiply(multiplier: Vector2 | number) {
        const delta = multiplier instanceof Vector2 ? multiplier : new Vector2(multiplier, multiplier);

        return new Bounds2(this.min.multiply(delta), this.max.multiply(delta));
    }
    overlap(compare: Bounds2) {
        if (this.max.x < compare.min.x || this.min.x > compare.max.x ||
            this.max.y < compare.min.y || this.min.y > compare.max.y) {
            return Bounds2.zeroEmpty;
        }
        return new Bounds2(
            new Vector2(Math.max(this.min.x, compare.min.x), Math.max(this.min.y, compare.min.y)),
            new Vector2(Math.min(this.max.x, compare.max.x), Math.min(this.max.y, compare.max.y))
        );
    }
    plus(offset: Vector2) {
        return new Bounds2(this.min.plus(offset), this.max.plus(offset));
    }
    size() {
        return new Vector2(this.max.x - this.min.x, this.max.y - this.min.y);
    }
    toString() {
        return `{min: ${this.min.toString()}, max: ${this.max.toString()}}`;
    }
    width() {
        return this.max.x - this.min.x;
    }
}